<template>
  <b-modal
    id="apk-download-modal"
    ref="modal"
    v-model="visible"
    hide-footer
    centered
    size="md"
    title="客户端下载"
    dialog-class="apk-download-modal-dialog"
    content-class="apk-download-modal-content"
    header-class="apk-download-modal-header"
    body-class="apk-download-modal-body p-4"
  >
    <div class="text-center">
      <!-- App Icon and Name -->
      <div class="app-icon-wrapper mb-3">
        <img :src="logoImg" alt="自在量化" class="app-logo shadow-sm" />
      </div>
      <h5 class="font-weight-bold mb-1 app-title">自在量化 Android 客户端</h5>
      <p class="text-muted small mb-3 app-subtitle">
        随时随地看盘复盘 · 情绪监控 · 题材推演
      </p>

      <!-- Badges -->
      <div class="d-flex justify-content-center align-items-center mb-3 flex-wrap">
        <span class="badge badge-primary mr-2 mb-1 px-2 py-1">
          <b-icon icon="phone" class="mr-1"></b-icon>v{{ versionInfo.version }} 正式版
        </span>
        <span class="badge badge-secondary mr-2 mb-1 px-2 py-1">
          <b-icon icon="hdd" class="mr-1"></b-icon>{{ versionInfo.fileSize }}
        </span>
        <span class="badge badge-info mb-1 px-2 py-1">
          <b-icon icon="calendar-check" class="mr-1"></b-icon>{{ versionInfo.releaseDate }}
        </span>
      </div>

      <!-- WeChat Notice -->
      <div v-if="isWeChat" class="alert alert-warning text-left small mb-3 p-2">
        <b-icon icon="exclamation-triangle-fill" class="mr-1 text-warning"></b-icon>
        <strong>微信提示：</strong>微信内可能拦截直接下载，请点击右上角 <strong>「···」</strong> 选择 <strong>「在浏览器打开」</strong>。
      </div>

      <!-- QR Code Area -->
      <div class="qr-code-box p-3 rounded mb-3 border">
        <div v-if="qrCodeDataUrl" class="qr-img-wrapper mb-2">
          <img :src="qrCodeDataUrl" alt="下载二维码" class="qr-img img-fluid" />
        </div>
        <div v-else class="py-4">
          <b-spinner variant="primary" small></b-spinner>
          <div class="small text-muted mt-2">二维码生成中...</div>
        </div>
        <div class="small font-weight-bold qr-tip">
          <b-icon icon="camera" class="mr-1"></b-icon>手机扫码直接下载安装
        </div>
        <div class="small text-muted mt-1" style="font-size: 0.75rem;">
          支持 Android 8.0 及以上系统
        </div>
      </div>

      <!-- Download Button -->
      <div class="download-action-group mb-3">
        <b-button
          variant="primary"
          block
          size="lg"
          class="font-weight-bold shadow-sm direct-download-btn py-2"
          :href="downloadUrl"
          download="zzapp-release-latest.apk"
          @click="onDownloadClick"
        >
          <b-icon icon="cloud-arrow-down-fill" class="mr-2"></b-icon>直接下载 APK 安装包
        </b-button>
      </div>

      <!-- Footer navigation -->
      <div class="d-flex justify-content-between align-items-center pt-2 border-top small">
        <router-link to="/download" class="text-primary font-weight-bold detail-page-link" @click.native="close">
          <b-icon icon="info-circle" class="mr-1"></b-icon>查看版本说明与特性介绍 →
        </router-link>
        <span class="text-muted">纯净无广告</span>
      </div>
    </div>
  </b-modal>
</template>

<script>
import QRCode from 'qrcode'

export default {
  name: 'ApkDownloadModal',
  data() {
    return {
      visible: false,
      logoImg: require('@/assets/img/logo.png'),
      qrCodeDataUrl: '',
      isWeChat: false,
      versionInfo: {
        version: '1.2.0',
        fileSize: '12.2 MB',
        releaseDate: '2026-09-17',
        downloadPath: 'https://file.zizizaizai.com/quant/downloads/zzapp-release-latest.apk'
      }
    }
  },
  computed: {
    downloadUrl() {
      const p = this.versionInfo.downloadPath || ''
      if (p.startsWith('http://') || p.startsWith('https://')) {
        return p
      }
      if (typeof window !== 'undefined') {
        return window.location.origin + p
      }
      return p
    },
    qrCodeUrl() {
      if (typeof window !== 'undefined') {
        return window.location.origin + '/download.html'
      }
      return '/download.html'
    }
  },
  mounted() {
    this.checkWeChat()
    this.generateQrCode()
  },
  methods: {
    open() {
      this.visible = true
      this.generateQrCode()
    },
    close() {
      this.visible = false
    },
    checkWeChat() {
      if (typeof navigator !== 'undefined') {
        const ua = navigator.userAgent.toLowerCase()
        this.isWeChat = ua.indexOf('micromessenger') !== -1
      }
    },
    async generateQrCode() {
      if (this.qrCodeDataUrl) return
      try {
        const targetUrl = this.qrCodeUrl
        const url = await QRCode.toDataURL(targetUrl, {
          width: 170,
          margin: 1,
          color: {
            dark: '#1e293b',
            light: '#ffffff'
          }
        })
        this.qrCodeDataUrl = url
      } catch (err) {
        console.error('Failed to generate APK download QR code:', err)
      }
    },
    onDownloadClick() {
      if (this.isWeChat) {
        this.$bvToast.toast('微信环境可能无法直接下载，建议点击右上角在系统浏览器打开', {
          title: '下载提示',
          variant: 'warning',
          solid: true,
          autoHideDelay: 4000
        })
      }
    }
  }
}
</script>

<style scoped>
.app-icon-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}

.app-logo {
  width: 58px;
  height: 58px;
  border-radius: 14px;
  object-fit: cover;
}

.app-title {
  color: var(--text-main, #1e293b);
  letter-spacing: 0.5px;
}

.app-subtitle {
  color: var(--text-muted, #64748b);
}

.qr-code-box {
  background-color: var(--bg-muted, #f8fafc);
  border-color: var(--border-color, #e2e8f0) !important;
}

.qr-img-wrapper {
  display: inline-block;
  background: #ffffff;
  padding: 8px;
  border-radius: 10px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
}

.qr-img {
  width: 150px;
  height: 150px;
  display: block;
}

.qr-tip {
  color: var(--text-main, #1e293b);
}

.direct-download-btn {
  border-radius: 8px;
  letter-spacing: 0.5px;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.direct-download-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.35) !important;
}

.detail-page-link {
  text-decoration: none;
}

.detail-page-link:hover {
  text-decoration: underline;
}

/* Dark mode overrides */
body.theme-dark .qr-code-box,
.theme-dark .qr-code-box {
  background-color: var(--bg-muted, #334155);
  border-color: var(--border-color, #334155) !important;
}
</style>
